export { DeleteCompany } from './DeleteCompany';
